(function () {
    'use strict';

    function commentsTile($timeout, $document, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/commentsTile.html',
            scope: {
                badgeContext: '=',
                popoverConfig: '=',
                noCommentsIconPath: '@',
                commentsIconPath: '@',
                commentsTileClass: '@' 
            },
            link: function (scope, element, attrs) {
                function setNoteBadgeData() {
                    scope.showBadge = true;
                    var comments = scope.badgeContext.ProjectUnderwritingNotes.filter(function (note) {
                        return !note.IsDeleted;
                    });
                    scope.badgeImage = comments.length == 0 ? scope.noCommentsIconPath : scope.commentsIconPath;
                    scope.badgeText = comments.length === 0 ? '' : comments.length;
                }

                setNoteBadgeData();
                var events = ["noteSaved", "noteRemoved", "noteResolved"];
                events.forEach(function (event) {
                    $rootScope.$on(event, function (event, args) {
                        if (args === scope.badgeContext.Path) {
                            setNoteBadgeData();
                        }
                    });
                });

                $rootScope.$on('updateWorkflowTitleBar', function () {
                    $timeout(function () { setNoteBadgeData(); }, 0);
                });
            }
        };
    }

    commentsTile.$inject = ['$timeout', '$document', '$rootScope'];

    angular.module('ecap.common').directive('commentsTile', commentsTile);
})();